// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// console.log(_.map([], (x) => { return x }))

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue"
// import "core-js/es6/promise"
// import "core-js/es6/string"
// import "core-js/es7/array"
import * as _datejs from "date-fns"
import scriptLoader from "script-loader"
import Vue from "vue"
import App from "./App"
import mixin from "./mixins/MixinBase"
import router from "./router"

// console.log(_.map([], (x) => { return x }))

// todo
import Element from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import "./assets/cpspCss/cpsp.css"
import "./assets/myCss/Theme.css"
import "./assets/myCss/navStyle.css"
import "./assets/myCss/secpStyle.css"
import "./assets/myFonts/iconfont.css"
import * as global from "./shared/global"
import i18n from "./shared/i18n"
import store from "./store"

import Print from "vue-print-nb"
import VueResize from "vue-resize"
import "vue-resize/dist/vue-resize.css"
import scroll from "vue-seamless-scroll" //滚动

import directives from "./shared/directives" //el-select
import checkP from "./shared/privilegeCheck"

Vue.use(Element, { size: "mini", i18n: (key, value) => i18n.t(key, value) })
Vue.use(VueResize)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.mixin(mixin) ///全局混入
Vue.use(Print) //vue 打印
Vue.use(scroll) //走马灯滚动条
Vue.use(scriptLoader)
Vue.use(directives)

const event_bus = new Vue()
Vue.prototype.$event_bus = event_bus
Vue.prototype.$date = _datejs //日期处理工具
Vue.prototype.$global = global
Vue.prototype.$checkP = checkP

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  store,
  router,
  template: "<App/>",
  components: {
    App
  }
});

